import { Box } from "@mui/material";
import React, { PropsWithChildren } from "react";
interface IPageContainer {
  title: React.ReactNode;
  actions?: React.ReactNode;
  /** Let the card grow to fit content wider than the viewport (e.g. a wide table) instead of clipping it. */
  fitWideContent?: boolean;
}
export const PageContainer: React.FC<PropsWithChildren<IPageContainer>> = ({
  title,
  actions,
  children,
  fitWideContent,
}) => {
  return (
    <div
      style={{
        borderRadius:16,
        backgroundColor: "white",
        padding: 18,
        paddingTop: 20,
        marginTop: 20,
        minHeight: "100%",
        width: fitWideContent ? "max-content" : "100%",
        minWidth: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: actions ? "space-between" : "flex-start",
          flexWrap: "wrap",
          columnGap: 2,
          rowGap: 1.5,
          mb: 2,
        }}
      >
        <h2 style={{ margin: 0 }}>{title}</h2>
        {actions && (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>{actions}</Box>
        )}
      </Box>
      {children}
    </div>
  );
};
